import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const Count = ({ number, text, align }) => {
  return (
    <div className={clsx('count', `count--align-${align}`)}>
      <span className="count__text ">{text}</span>
      <span className="count__number ">{number}</span>
    </div>
  );
};

Count.propTypes = {
  align: PropTypes.oneOf(['default', 'left']),
};

Count.defaultProps = {
  align: 'default',
};

export default Count;
